export class RouterUtil {
    private static Configuration = {
        About: 'about',
        Account: 'account',
        AddressBook: 'address-book',
        Cart: 'cart',
        Checkout: 'checkout',
        Contact: 'contact',
        Detail: 'detail',
        ForgotPassword: 'forgot-password',
        Home: 'home',
        Login: 'login',
        Notifications: 'notifications',
        Orders: 'orders',
        OrderDetail: 'orders/:id',
        Products: 'products',
        Profile: 'profile',
        Register: 'register',
        ResetPassword: 'reset-password',
        Setting: 'setting',
        Shop: 'shop',
        Shops: 'shops',
        Status: 'status',
        Unavailable: 'unavailable',
        Verify: 'verify',
        Rating: 'rating',
        Stores: 'stores',
        DeliveryAddress: 'delivery-address',
        DeliveryAddresses: 'delivery-addresses',
        SelectDeliveryAddress: 'select-delivery-address',
        Tracking: 'tracking',
        SelectStore: 'select-store',
        ShopId: 'shopId',
        ProductId: 'productId',
        OrderId: 'orderId',
        TreatmentCard: 'treatment-card'
    };

    public static Cog = this.Configuration;
}
